export default __webpack_public_path__ + "static/media/project3.8f7386f9.png";